/**
 * <collections-comparison-slider>
 *
 * A small, dependency-free auto-rotating image crossfade, one per comparison
 * column. Replaces the previous theme's jQuery/Slick carousel.
 */

const ROTATE_INTERVAL_MS = 4000;

class CollectionsComparisonSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.collections-comparison__slide'));
    if (this.slides.length < 2) return;

    this.activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (this.activeIndex < 0) this.activeIndex = 0;

    this.timer = window.setInterval(() => this.next(), ROTATE_INTERVAL_MS);
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
  }

  next() {
    this.slides[this.activeIndex]?.classList.remove('is-active');
    this.activeIndex = (this.activeIndex + 1) % this.slides.length;
    this.slides[this.activeIndex]?.classList.add('is-active');
  }
}

if (!customElements.get('collections-comparison-slider')) {
  customElements.define('collections-comparison-slider', CollectionsComparisonSlider);
}
